import Home from './Home.data-manager-bundle-wl-details.vue'

export default {
  Home
}